import React, { ReactNode } from 'react';
import { PerksLayout } from '../../components/phoneVerify/themeLayouts/perks/PerksLayout';
import { DefaultLayout } from '../../components/phoneVerify/themeLayouts/default/DefaultLayout';
import { trackingContext } from '@jbhi-fi/components/src/Tracking';

export enum pageThemeEnum {
  default = 'default',
  perks = 'perks',
  perksSuccess = 'perksSuccess',
}

export const getGtmData = () => {
  const pageTheme = getPageThemeFromUrl(window.location.href);
  const gtmContext = window.location.href.includes('receipt') ? trackingContext.receipts : trackingContext.account;

  let gtmCategory = gtmContext === trackingContext.receipts ? 'eReceipts' : 'my account';
  if (pageTheme === pageThemeEnum.perks) {
    gtmCategory = `${gtmCategory} - JB Perks`;
  }

  return { category: gtmCategory, context: gtmContext };
};

export const getPageThemeFromUrl = (url: string): pageThemeEnum => {
  if (window.location.pathname?.startsWith('/pages/receipts')) {
    return pageThemeEnum.perks;
  }
  return pageThemeEnum[new URL(url).searchParams.get('pageTheme')] ?? pageThemeEnum.default;
};

export type PageThemeLayout = React.FC<{ children: React.ReactNode }>;

const PerksSuccessLayout = ({ children }: { children: ReactNode }) => <>{children}</>;

export const getVerifyLayout = (pageTheme?: string): PageThemeLayout => {
  switch (pageTheme) {
    case pageThemeEnum.perks:
      return PerksLayout;
    case pageThemeEnum.perksSuccess:
      return PerksSuccessLayout;
    default:
      return DefaultLayout;
  }
};
